import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import { PageIntro } from '../pageintro';
import { Input, TextArea, CheckBox } from './input';

interface Props {
  regNr?: string;
  gdprText: string;
  newsletterText: string;
  financing: boolean;
  onlyProducts: boolean;
  rental: boolean;
  setBookingValues: (value: mrCap.BookingRequest) => void;
}

interface State {
  name: string;
  regNr: string;
  phone: string;
  email: string;
  comment: string;
  consent: boolean;
  newsletter: boolean;
  rentalConsent: boolean;
  driversLicenseNumber: string;
}

/** Filter keys from type `T` of type `TK`. */
type FilteredKeyOf<T, TK> = keyof Pick<T, {
  [K in keyof T]: T[K] extends TK ? K : never
}[keyof T]>;

export class UserInfo extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      name: '',
      regNr: props.regNr?.toUpperCase() ?? '', // Use same regnr if it already exists from previous step.
      phone: '',
      email: '',
      comment: '',
      consent: false,
      newsletter: true,
      rentalConsent: false,
      driversLicenseNumber: ''
    };
  }

  setValue = <T,>(key: FilteredKeyOf<State, T>) => {
    return (value: T) => {
      this.setState({ [key]: value } as any);
      this.props.setBookingValues({ [key]: value } as any);
    };
  };

  render() {

    return (
      <div className='user-info-container'>
        {<i className='far fa-edit'></i>}

        <PageIntro header={'Dina uppgifter'} />

        <div className='form'>
          {!this.props.financing && <>
            <Row width={50}>
              <Input
                placeholder='För- och efternamn *'
                autoComplete='name'
                value={this.state.name}
                change={this.setValue('name')} />
            </Row>
          </>}
          {!this.props.onlyProducts && <>
            <Row width={this.props.financing ? 100 : 50}>
              <Input
                placeholder='ABC12X'
                value={this.state.regNr}
                readOnly={!!this.props.regNr}
                change={this.setValue('regNr')}
                className={`late-regnr-set ${!!this.props.regNr ? 'locked' : ''}`} />
              {!!this.props.regNr && <><i className='fas fa-lock'></i></>}
            </Row>
          </>}
          {!this.props.financing && <>
            <Row width={50}>
              <Input
                placeholder='Telefonnummer'
                autoComplete='phone'
                value={this.state.phone}
                change={this.setValue('phone')} />
            </Row>
            <Row width={50}>
              <Input
                placeholder='E-postadress *'
                type='email'
                autoComplete='email'
                value={this.state.email}
                change={this.setValue('email')} />
            </Row>
          </>}

          {this.props.rental && <>
            <Row width={100}>
              <Input
                placeholder='Körkortsnummer för hyrbil *'
                type='text'
                value={this.state.driversLicenseNumber}
                change={this.setValue('driversLicenseNumber')} />
            </Row>
          </>}

          <Row width={100}>
            <TextArea
              placeholder='Meddelande'
              value={this.state.comment}
              change={this.setValue('comment')} />
          </Row>
          {!this.props.financing && <>
            <Row width={100}>
              <CheckBox
                title={this.props.gdprText}
                checked={this.state.consent}
                change={this.setValue('consent')} />
            </Row>
          </>}
          <Row width={100}>
            <CheckBox
              title={this.props.newsletterText}
              checked={this.state.newsletter}
              change={this.setValue('newsletter')} />
          </Row>

          {this.props.rental && <>
            <Row width={100}>
              <CheckBox
                title={'Jag accepterar <a href="https://www.mabi.se/villkor" target="_blank">MABI:s villkor</a>'}
                checked={this.state.rentalConsent}
                change={this.setValue('rentalConsent')} />
            </Row>
          </>}
        </div>
      </div>
    );
  }
}

function Row(props: React.PropsWithChildren<{children?: React.ReactNode; width: number}>) {
  return <div className={`form-node-${props.width}`}>{props.children}</div>;
}
